<template>
    <div class="wrapper col">
        <h1><Spinner size="30px" /></h1>
    </div>
</template>

<script>
import { jsonp } from 'vue-jsonp'

import { auth } from '../../db'

import Spinner from '../tools/Spinner'

export default {
    name: 'LinkedIn',
    components: {
        Spinner
    },
    methods: {
        tokenReceived(data) {
            if (data.token) {
                auth.signInWithCustomToken(data.token).then( () => {
                    this.notif('Sign In Successful')
                    this.$router.push('/profile')
                }).catch( (e) => {
                    this.error('Could not sign in to Monroe with LinkedIn')
                    console.error(e)
                    this.$router.push('/login')
                })
            } else {
                console.error(data)
                if (data.error == 'email-in-use') {
                    this.error('Hey, another account is already using that email!')
                }
                else {
                    this.error('Could not sign in to LinkedIn')
                }
                this.$router.push('/login')
            }
        },
        async requestToken() {
            // This is the URL to the HTTP triggered 'token' Firebase Function.
            // See https://firebase.google.com/docs/functions.
            var tokenFunctionURL = 'https://monroe.live/api/token';
            // Use JSONP to load the 'token' Firebase Function to exchange the auth code against a Firebase custom token.
            const data = await jsonp(tokenFunctionURL, {
                code: this.$route.query.code,
                state: this.$route.query.state,
            }, 60000)
            this.tokenReceived(data)
        }
    },
    created() {
        if (this.$route.query.error) {
            console.error('Error from the LinkedIn auth page: ' + this.$route.query.error)
            this.error('LinkedIn auth error')
            this.$router.push('/login')
        }
        else if (!this.$route.query.code) {
            window.location.href  = 'https://monroe.live/api/redirect'
        }
        else {
            this.requestToken().catch(e => {
                console.error(e)
                this.error('Error signing in to LinkedIn')
                this.$router.push('/login')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';
</style>